<div class="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4">
  @if (isCardVisible(roleEnums.PRECISE)) {
    <div class="col">
      <div class="card h-100">
        <img src="/assets/logos/ICON-WHITE-PRECISE.svg" class="card-img-top precise-predict" alt="PRECISE" />
        <div class="card-body">
          <h5 class="card-title">
            <h4 id="preciseSlogan" class="text-center" style="font-size: 19px; padding-bottom: 10px; color: #6e6e6e">
              <span class="precise-letter">P</span>roven
              <span class="precise-letter">R</span>eliable
              <span class="precise-letter">E</span>pidemiology
              <span style="font-style: italic; font-size: 14px">for </span>
              <span class="precise-letter">C</span>ancer
              <span class="precise-letter">I</span>nformation,
              <span class="precise-letter">S</span>egmentation
              <span style="font-style: italic; font-size: 14px">and </span>
              <span class="precise-letter">E</span>xtrapolation
            </h4>
          </h5>
          <div class="card-text">
            <ul>
              <li>
                With 35+ tumors (solid and hematopoietic) and 80+ countries,
                one can query any combination of factors customized for your
                business area.
              </li>
              <li>
                Each country specific data set has been rigorously analyzed to
                create an accurate view of the epidemiology of specific cancer
                types.
              </li>
              <li>
                The database is fully documented with the sources and
                assumptions used to support the global numbers
              </li>
            </ul>
          </div>
        </div>
        <div class="card-footer">
          <div class="row">
            <div [ngClass]="isAppAccessible(roleEnums.PRECISE) ? 'col-6' : 'col-12'">
              <div class="d-grid gap-2">
                <a (click)="logEvent('More Info', 'Precise')" href="https://tessellon.com/products/precise"
                target="_blank" class="btn btn-outline-primary" type="button">More Info</a>
              </div>
            </div>
            @if (isAppAccessible(roleEnums.PRECISE)) {
              <div class="col-6">
                <div class="d-grid gap-2">
                  <a (click)="logEvent('App Launch', 'Precise')" href="{{appBaseUrl}}/precise" class="btn btn-primary"
                  type="button">Launch PRECISE</a>
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  }
  @if (isCardVisible(roleEnums.PRECISE_Biomarkers)) {
    <div class="col">
      <div class="card h-100">
        <img src="/assets/logos/WHITE-PRECISE.svg" class="card-img-top precise-predict" alt="PRECISE Biomarkers" />
        <div class="card-body">
          <h5 class="card-title">
            <h4 id="preciseSlogan" class="text-center" style="font-size: 30px; padding-bottom: 10px; color: white">
              Biomarkers
            </h4>
          </h5>
          <div class="card-text">
            <ul>
              <li>
                With experience in 1100+ genetic biomarkers in 30+ cancers, you can
                query any combination of factors needed for your business
                area.
              </li>
              <li>
                Each data set has been rigorously analyzed to create
                an accurate view of the epidemiology of specific biomarkers
                as they pertain to each type of cancer.
              </li>
              <li>
                The database is fully
                documented with the sources and assumptions used to
                support the numbers
              </li>
            </ul>
          </div>
        </div>
        <div class="card-footer">
          <div class="row">
            <div [ngClass]="isAppAccessible(roleEnums.PRECISE_Biomarkers) ? 'col-6' : 'col-12'">
              <div class="d-grid gap-2">
                <a (click)="logEvent('More Info', 'Biomarkers')" href="https://tessellon.com/products/biomarkers"
                target="_blank" class="btn btn-outline-primary" type="button">More Info</a>
              </div>
            </div>
            @if (isAppAccessible(roleEnums.PRECISE_Biomarkers)) {
              <div class="col-6">
                <div class="d-grid gap-2">
                  <a (click)="logEvent('App Launch', 'Biomarkers')" href="{{appBaseUrl}}/biomarkers" class="btn btn-primary"
                  type="button">Launch Biomarkers</a>
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  }
  @if (isCardVisible(roleEnums.PREDICT)) {
    <div class="col">
      <div class="card h-100">
        <img src="/assets/logos/ICON-WHITE-PREDICT.svg" class="card-img-top precise-predict" alt="PREDICT" />
        <div class="card-body">
          <h5 class="card-title">
            <h4 id="predictSlogan" class="text-center" style="font-size: 19px; color: #6e6e6e; padding-bottom: 10px">
              <span class="predict-letter">P</span>roven
              <span class="predict-letter">R</span>eliable
              <span class="predict-letter">E</span>pidemiology
              <span style="font-style: italic; font-size: 14px">for </span>
              <span class="predict-letter">D</span>ecisions,
              <span class="predict-letter">I</span>nforming,
              <span class="predict-letter">C</span>ommunication
              <span style="font-style: italic; font-size: 14px">and </span>
              <span class="predict-letter">T</span>actics
            </h4>
          </h5>
          <div class="card-text">
            <ul>
              <li>
                With experience in 50+ diseases in 10+ therapeutic areas
                throughout 80+ countries, one can query any combination of
                factors customized for your business area.
              </li>
              <li>
                Each country specific data set has been rigorously analyzed to
                create an accurate view of the epidemiology of specific
                diseases.
              </li>
              <li>
                The database is fully documented with the sources and
                assumptions used to support the global numbers.
              </li>
            </ul>
          </div>
        </div>
        <div class="card-footer">
          <div class="row">
            <div [ngClass]="isAppAccessible(roleEnums.PREDICT) ? 'col-6' : 'col-12'">
              <div class="d-grid gap-2">
                <a (click)="logEvent('More Info', 'Predict')" href="https://tessellon.com/products/predict"
                target="_blank" class="btn btn-outline-primary" type="button">More Info</a>
              </div>
            </div>
            @if (isAppAccessible(roleEnums.PREDICT)) {
              <div class="col-6">
                <div class="d-grid gap-2">
                  <a (click)="logEvent('App Launch', 'Predict')" href="{{appBaseUrl}}/predict" class="btn btn-primary"
                  type="button">Launch PREDICT</a>
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  }
  @if (isCardVisible(roleEnums.DxPro)) {
    <div class="col">
      <div class="card h-100">
        <img src="/assets/logos/ICON-WHITE-DXPRO-2.svg" class="card-img-top dxpro" alt="DxPro" />
        <div class="card-body">
          <div class="card-text">
            <div>
              <ul>
                <li>
                  Searchable database of diagnosed patients and procedures
                  conducted in U.S. hospitals.
                </li>
                <li>
                  Up to 40 diagnosis fields and 25 procedure fields are
                  captured for each patient
                </li>
                <li>
                  Includes a user friendly tool for searching and defining
                  groups of ICD-10-CM and ICD-10-PCS codes
                </li>
              </ul>
            </div>
            <div>
              <ul>
                <li>
                  The ICD-10-CM is a morbidity classification published by the
                  United States for classifying diagnoses and reason for
                  visits in all health care settings. The ICD-10-CM is based
                  on the ICD-10, the statistical classification of disease
                  published by the World Health Organization (WHO).
                </li>
                <li>
                  ICD-10-PCS is the official system of assigning codes to
                  procedures associated with hospital utilization in the
                  United States. ICD-10-PCS codes support data collection,
                  payment and electronic health records. ICD-10-PCS is a
                  medical classification coding system for procedural codes.
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="card-footer">
          <div class="row">
            <div [ngClass]="isAppAccessible(roleEnums.DxPro) ? 'col-6' : 'col-12'">
              <div class="d-grid gap-2">
                <a (click)="logEvent('More Info', 'DxPro')" href="https://tessellon.com/products/dxpro" target="_blank"
                class="btn btn-outline-primary" type="button">More Info</a>
              </div>
            </div>
            @if (isAppAccessible(roleEnums.DxPro)) {
              <div class="col-6">
                <div class="d-grid gap-2">
                  <a (click)="logEvent('App Launch', 'DxPro')" href="{{appBaseUrl}}/dxpro" class="btn btn-primary"
                  type="button">Launch DxPro</a>
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  }
  @if (isCardVisible(roleEnums.VennHealth)) {
    <div class="col">
      <div class="card h-100">
        <img src="/assets/logos/ICON-WHITE-VENNHEALTH.svg" class="card-img-top vennhealth" alt="VennHealth" />
        <div class="card-body">
          <div class="card-text">
            <ul>
              <li>
                VennHealth is tool for analyzing co-morbidity among various
                conditions in the U.S. population.
              </li>
              <li>
                It covers a wide variety of diseases/conditions, including
                life style diseases
              </li>
              <li>
                Allows users to look at both exclusive and overlapping
                conditions
              </li>
              <li>
                Many diseases/conditions diagnostic criteria can be custom
                defined
              </li>
            </ul>
          </div>
        </div>
        <div class="card-footer">
          <div class="row">
            <div [ngClass]="isAppAccessible(roleEnums.VennHealth) ? 'col-6' : 'col-12'">
              <div class="d-grid gap-2">
                <a (click)="logEvent('More Info', 'VennHealth')" href="https://tessellon.com/products/vennhealth"
                target="_blank" class="btn btn-outline-primary" type="button">More Info</a>
              </div>
            </div>
            @if (isAppAccessible(roleEnums.VennHealth)) {
              <div class="col-6">
                <div class="d-grid gap-2">
                  <a (click)="logEvent('App Launch', 'VennHealth')" href="{{appBaseUrl}}/vennhealth" class="btn btn-primary"
                  type="button">Launch VennHealth</a>
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  }
  @if (isCardVisible(roleEnums.US_COUNTY_FIPS)) {
    <div class="col">
      <div class="card h-100">
        <h2 class="pt-3 text-center" style="color: whitesmoke">
          US County Level Disease Populations
        </h2>
        <div class="card-body">
          <div class="card-text">
            <ul>
              <li>Disease epidemiology by county in the US can be determined for any disease (cancer, COVID, etc.) and
              viewed in an interactive map and table of results.</li>
              <li>There are ~3,000 FIPS coded counties in the US across the 50 States and District of Columbia.</li>
              <li>Tessellon utilizes county specific population statistics by sex, age and ethnicity from the United
              States Census Bureau to develop county and state populations for diseases.</li>
            </ul>
          </div>
        </div>
        <div class="card-footer">
          <div class="row">
            <div [ngClass]="isAppAccessible(roleEnums.US_COUNTY_FIPS) ? 'col-6' : 'col-12'">
              <div class="d-grid gap-2">
                <a (click)="logEvent('More Info', 'County FIPS')" href="https://tessellon.com/realworldevidence"
                target="_blank" class="btn btn-outline-primary" type="button">More Info</a>
              </div>
            </div>
            @if (isAppAccessible(roleEnums.US_COUNTY_FIPS)) {
              <div class="col-6">
                <div class="d-grid gap-2">
                  <a (click)="logEvent('App Launch', 'County FIPS')" href="{{appBaseUrl}}/countyfips"
                  class="btn btn-primary" type="button">Launch</a>
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  }
  @if (isCardVisible(roleEnums.Admin)) {
    <div class="col">
      <div class="card h-100">
        <div class="card-body">
          <div class="card-text">
            <div class="tessellon-logo-container">
              <div class="tessellon-logo">
                <span class="tessellon-logo-text">Tessellon</span>
                <span class="tessellon-logo-text-ai">Intelligence</span>
              </div>
            </div>
            <ul>
              <li>AI powered research and business intelligence</li>
              <li style="font-style: italic; color: red;">For internal use only</li>
            </ul>
          </div>
        </div>
        <div class="card-footer">
          <div class="row">
            @if (isAppAccessible(roleEnums.Admin)) {
              <div class="col-12">
                <div class="d-grid gap-2">
                  <a (click)="logEvent('App Launch', 'TCRI')" href="{{appBaseUrl}}/tcri" class="btn btn-primary"
                  type="button">Launch TI</a>
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  }
</div>